// src/admin/components/DeleteConfirmModal.js
import React, { useState } from 'react';
import './DeleteConfirmModal.css';

const DeleteConfirmModal = ({ user, onConfirm, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [confirmText, setConfirmText] = useState('');

  const handleConfirm = async () => {
    try {
      setLoading(true);
      await onConfirm();
    } catch (err) {
      console.error('Failed to delete user:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-container modal-sm" onClick={(e) => e.stopPropagation()}>
        <div className="delete-modal">
          <div className="delete-icon-wrapper">
            <i className="bi bi-exclamation-triangle"></i>
          </div>

          <h2>Delete User?</h2>
          
          <div className="user-delete-info">
            <div className="user-avatar-small">
              {user.name.charAt(0).toUpperCase()}
            </div>
            <div>
              <p className="user-name">{user.name}</p>
              <p className="user-email">{user.email}</p>
            </div>
          </div>

          <div className="warning-box">
            <i className="bi bi-shield-exclamation"></i>
            <div>
              <p><strong>This action cannot be undone.</strong></p>
              <p>All user data, including projects and history, will be permanently deleted.</p>
            </div>
          </div>

          <div className="confirm-input-group">
            <label htmlFor="confirm-delete">
              Type <strong>DELETE</strong> to confirm:
            </label>
            <input
              type="text"
              id="confirm-delete"
              value={confirmText}
              onChange={(e) => setConfirmText(e.target.value)}
              placeholder="Type DELETE"
              className="confirm-input"
            />
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn-secondary"
              onClick={onClose}
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn-danger"
              onClick={handleConfirm}
              disabled={loading || confirmText !== 'DELETE'}
            >
              {loading ? (
                <>
                  <span className="spinner-small"></span>
                  Deleting...
                </>
              ) : (
                <>
                  <i className="bi bi-trash"></i>
                  Delete User
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;